/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import {GeneralCommentModalApp} from "../Functionality/GeneralCommentModalApp";
import CustomModal from "../../../../components/Modal/CustomModal";
import DivContainerBody from "../../../../components/DivContainerBody";
import {CustomTextField} from "../../../../components/CustomTextField";
import {STATUS_MODEL} from "../../../../enums/statusEnum";

const GeneralCommentModal = (props) => {

    const {onHide, title, setModified, modified,row,status, module,endPoint, trans='comment', placeholder} = props

    const {
        resetValues,
        emptyFields,
        handleChange,
        t,
        handleCreate,
        data,
        infoParagraph
    } = GeneralCommentModalApp({onHide,setModified, modified,row ,status,module,endPoint})


    return (
        <CustomModal
            {...props}
            title={t(title)}
            size='md'
            onConfirm={() => {
                handleCreate(status)
            }}
            onHide={() => {
                onHide();
                resetValues();
            }}
            classNameBody="pt-2"
        >
            <DivContainerBody>
                <div className={"d-flex flex-column justify-content-center gap-2 align-items-center"}>
                    <p className={"ibl-ientry-p ibl-font-w-400"}>{t('are_you_sure_to_proceed')}</p>
                    <p className={"ibl-ientry-p ibl-font-w-600 text-uppercase"}>{t(infoParagraph)}</p>
                </div>
                <div className={"mt-3"}>
                    <CustomTextField
                        length={512}
                        id='txt_gcm_reason'
                        name='reason'
                        value={data?.reason}
                        trans={trans}
                        emptyFields={emptyFields}
                        required={status !== STATUS_MODEL.APPROVED}
                        onChange={handleChange}
                        multiline={true}
                        row={4}
                        placeholder={placeholder}
                    />
                </div>
            </DivContainerBody>
        </CustomModal>
    );
};

export default GeneralCommentModal
